<script>

    import { state, res, ui, prefs, live } from './stores.js';
    export let c;
    export let facedown = false;
    //import { textfit } from 'svelte-textfit';
    import { fit, parent_style } from '@leveluptuts/svelte-fit'
    import { convert, toggleSelect, isSelected, isTouchDevice } from './ui.js';
    import { getCardURL, getIconURL, getShipCode, hasOfficialImage, officialImage } from './card_images.js';
    import { look, isBeingLookedAt } from './card_actions.js'
    import NewCardImage from './newcards/NewCardImage.svelte';
    import { currentTraits } from './parse.js';

    export let selectable = true;
    export let rotated = false;
    export let useImages = -1;
    export let width = $res.cardWidth * $prefs.cardScale;
    export let height = $res.cardHeight * $prefs.cardScale;
    export let units = 'vmin';
    export let isPreview = false;

    let cardBack = 'standard';
    //if(c && c.suits.includes('location')) cardBack = 'location';
    if(c && c.suits && c.suits.includes('mission')) cardBack = 'mission';

    let parent;
    let textParent, extraParent, goalParent, rewardParent, specialParent, costParent;

    

    function fullText(c){
        let text = c.playText || '';
        if(c.ongoingText) text = `${text}<p/>${c.ongoingText}`;
        if(c.incomeText) text = `${text}<p/>${c.incomeText}`;
        if(c.reward) text = `${text}<p/>Reward: ${c.reward}`;
        if(c.goal) text = `${text}<p/>${c.goal}`;
        if(c.cleanupText) text = `${text}<p/>${c.cleanup}`;
        return text;
    }

    function getWidth(c){
        //if(c.icons.includes('pinned') || c.icons.includes('traderoute-pin') || c.area.startsWith('Power')) return 'calc(var(--width) / 1.3)';
        //if(c.icons.includes('attack'))return 'calc(var(--width) / 1.43)';
        return 'calc(var(--width) / 1.05 - var(--width) / 7)'
    }

    function style(node,value){
        node.style.display = 'flex';
        node.style.alignItems = 'left';
        node.style.justifyContent = 'left';
        node.style.fontSize = value + "px";
    }

    function textProportion(c){
        let num = 0;
        if(c.playText) num++;
        if(c.ongoingText) num++;
        if(c.incomeText) num++;
        if(c.reward) num++;
        if(c.goal) num++;
        if(c.cleanupText) num++;
        //if(c.power) num++;
       // console.log(Math.ceil(1 / num * 3));
        return `calc(var(--height) / ${Math.ceil(num * 3)} + 1px)`
    }

    function textSize(c){
        let totalText = 0;
        if(c.playText) totalText += c.playText.length;
        if(c.ongoingText) totalText += c.ongoingText.length;
        if(c.reward) totalText += c.reward.length;
        if(c.goal) totalText += c.goal.length;

        let div = 34;
        
        if(isPreview){
            return `font-size: ${(80 * $prefs.previewScale / 38).toFixed(2)}mm;`
        }else{
            return `font-size: ${($res.cardWidth / 38).toFixed(2)}vmin`;
        }
        //let totalText = 0;
        if(c.playText) totalText += c.playText.length;
        if(c.ongoingText) totalText += c.ongoingText.length;
        if(c.reward) totalText += c.reward.length;
        if(c.goal) totalText += c.goal.length;
        let sizeCalc = width * 0.7 * height * 0.5 / (totalText * (units == 'mm' ? 3 : 1));
        
        let size = `font-size: clamp(4px, ${sizeCalc.toFixed(2)}${units}, ${(units == 'mm' ? '20px' : '50%')});`
        return size;
    }

    function nameSize(c){
        if(isPreview){
            return `font-size: ${(80 * $prefs.previewScale / 18).toFixed(2)}mm;`
        }else{
            return `font-size: ${($res.cardWidth / 18).toFixed(2)}vmin`;
        }
        let sizeCalc = width * 0.7 / c.name.length;
        return `clamp(6px, ${sizeCalc.toFixed(2)}vmin, ${(units == 'mm' ? '40px' : '12px')});`
    }

    let templateLinks = ['ship', 'person', 'cargo', 'captain', 'encounter', 'incident', 'mission', 'location', 'ally']
    
    function getTemplate(c){
        if(c.suits && templateLinks.includes(c.suits[0])) return `-${c.suits[0]}`;
        return '-none';
    }

    function handleClick(c){
        console.log(c, selectable)
        if(selectable){
            toggleSelect(c, facedown)
        }else if(c && c.suits &&  c.suits.includes('mission')){
            if(!isBeingLookedAt(c)){
                look(c); // To look at missions
            }
            $live.hoveringCard = c;
        }
    }
</script>
{#if !c || !c.name}
        <div class="nocard" style="width:{$res.cardWidth * $prefs.cardScale}vmin; height: {$res.cardHeight * $prefs.cardScale}vmin;"/>
    {:else if facedown}
        {#if !$prefs.oldCards}
            <div class:rotated={rotated} class="card_image" style="width: var(--width); height: var(--height); background-color: white;" on:click={e => { if(!isTouchDevice()) handleClick(c); } } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }>
                <img style="width:100%; height: 100%;" src="./cards/back.png" />
            </div>
        {:else}       
            <div class="facedown_{cardBack}" style="width:{$res.cardWidth * $prefs.cardScale}vmin; height: {$res.cardHeight * $prefs.cardScale}vmin;" on:click={e => { if(!isTouchDevice()) handleClick(c); } } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }/>
        {/if}
    {:else if hasOfficialImage(c) && $prefs.useCardImages && !c.savedTraits && !c.savedValues && !c.savedTypeGains}<!--/*&& !c.savedTraits && !c.savedValues && !c.savedTypeGains*/-->
        <div class:rotated={rotated} class="card_image" style="width: var(--width); height: var(--height); background-color: white;" on:click={e => { if(!isTouchDevice()) handleClick(c); } } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }>
            <img style="width:100%; height: 100%;" src="./cards/{officialImage(c)}.png" />
        </div>
    {:else if !$prefs.oldCards}
        <NewCardImage {c} card={{...$res.atCards[c.id], traits: currentTraits(c), skills: c.values}} operations={$res.atOps[c.id]} {handleClick} />
    {:else if (useImages == true || useImages == -1 && $prefs.useCardImages) && getCardURL(c) && !c.temporaryTraits && !c.savedTraits} <!-- && !$res.stagingSheet -->
        <div class:rotated={rotated} class="card_image" style="width: var(--width); height: var(--height); background-color: white;" on:click={e => { if(!isTouchDevice()) handleClick(c); } } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }>
            <img style="width:100%; height: 100%;" src={getCardURL(c)} />
        </div>
    {:else}
        <div class:rotated={rotated} class="card {c.suits[0] && $prefs.colourCards ? c.suits[0] + ' faded' : ''}" style={`width: 100%; height: 100%; background-image: url("links/card-template${getTemplate(c)}.png");`} on:click={e => { if(!isTouchDevice()) handleClick(c);} } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }>
            <div class="name" class:mission_text={c.blue} class:incident_text={c.red} style={`width: ${getWidth(c)}; font-weight: bold; ${nameSize(c)}`}>{c.name.replace(/\$/g, '')}</div>
            <div class="text_holder" style="{textSize(c)}">
                {#if c.playText}
                    <div class="text">
                        <div class="fitted_text" style="display: block">{@html convert(c.playText, true)}</div>
                    </div>
                {/if}
                {#if c.ongoingText}
                    <div class="ongoing" >
                        <div class="fitted_text" style="display: block">{@html convert(c.ongoingText, true)}</div>
                    </div>
                {/if}
                {#if c.incomeText}
                    <div class="income" >
                        <div class="fitted_text" style="display: block">{@html convert(c.incomeText, true)}</div>
                    </div>
                {/if}
                {#if c.goal}
                    <div class="goal">
                        <div class="fitted_text" style="display: block;">{@html convert(c.goal, true)}</div>
                    </div>
                {/if}
                {#if c.reward}
                    <div class="reward" >
                        <div class="fitted_text" style="display: block;" >{@html convert(c.reward, true)}</div>
                    </div>
                {/if}
                {#if c.cleanupText}
                    <div class="cleanup" >
                        <div class="fitted_text" style="display: block;" >{@html convert(c.cleanupText, true)}</div>
                    </div>
                {/if}
                {#if c.devCost}
                    <div class="devcost" style="text-align: center">
                        <div class="fitted_text" style="display: block;">{@html convert(c.devCost, false)}</div>
                    </div>
                {/if}
                
            </div>
            
            <div class="suits">
                {#each c.suits as s}
                    <img src={getIconURL(s)} />
                {/each}
            </div>
            <div class="values">
                {#each c.values as s}
                    <img class="value_image" src="value-{s}.png" />
                {/each}
                {#each c.ships as s (getShipCode(c.uniqueID, s))}
                    {#if getIconURL(s)}
                        <img class="value_image ship" src={getIconURL(s)} />
                    {:else}
                        <div class="value_image ship ship_text">🚀{getShipCode(c.uniqueID, s)}</div>
                    {/if}
                {/each}
            </div>
            <div class="traits">
                {#each currentTraits(c) as s}
                    <div class="trait_block">
                        <img class="trait_image" src={getIconURL(s)} />
                        <div class="trait_text" class:species_text={$res.species.includes(s)}>{s[0].toUpperCase()}{s.slice(1)}</div>
                    </div>
                {/each}
            </div>
            {#if c.stripe}
                <img class="stripe" src="stripe-{c.stripe}.png" />
            {/if}
            {#if c.vp}
                <div class="vp" class:negative={c.vp < 0}>
                    {c.vp}
                </div>
            {:else if c.focus_vp}
                <div class="vp">
                    ?
                </div>
            {/if}
            {#if c.id}
                <div class="ref">
                    {c.id}
                </div>
            {/if}
            <div class="pips">
                {#each Array(c.pips) as _}
                    <img class="pip" src="pip.png" />
                {/each}
            </div>
            {#if c.attack}
                <img class="attack" src={getIconURL('attack_indicator')} />
            {/if}
            
        </div>
{/if}

<style>
.generic {
    background-color: grey;
    color: white;
    border-top: 2px solid black;
    border-bottom: 2px solid black;
}

img {
        height: calc(var(--width) / 5.53);
        width: calc(var(--width) / 5.53);
    }
.card {
        background-color: whitesmoke;
        background-image: url("card-template.png");
        background-repeat: no-repeat;
        background-size: contain;
        color: black;
        position: relative;
        font-family: sans-serif;
        border: 1px solid black;
        box-sizing: border-box;
        font-weight: normal;
        font-style: normal;
    }

    .card_image {
        border: 1px solid black;
        background-size: contain;
		background-position: center;
		background-repeat: no-repeat; 
        box-sizing: border-box;
    }

    .nocard {
        background-color: black;
        border: 1px solid white;
        box-sizing: border-box;
    }

    .facedown {
        background-color: darkblue;
        border: 1px solid white;
        box-sizing: border-box;
    }

    .facedown_standard {
        background-color: darkblue;
        border: 1px solid white;
        box-sizing: border-box;
    }

    .facedown_location {
        background-color: darkgreen;
        border: 1px solid white;
        box-sizing: border-box;
    }

    .facedown_mission {
        background-color: lightblue;
        border: 1px solid white;
        box-sizing: border-box;
    }

    .name {
        position: absolute;
        top: calc(var(--height) / 40);
        left: calc(var(--width) / 7);
        padding-top: calc(var(--height) / 400);
        padding-bottom: calc(var(--height) / 400);
        display: flex;
        align-items: flex-end;
        transform: scale(0.8, 1);
        transform-origin: left;
        /*font-size: calc(var(--height) / 17.5);*/
        height: calc(var(--height) / 10);
        max-width: calc(var(--width) * 0.8);
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: orange;
    }

    .mission_text {
        color: cornflowerblue;
    }

    .incident_text {
        color: red;
    }

    .ship_text {
        font-weight: bold;
        font-size: calc(var(--height) / 7);
    }

    .attack {
        position: absolute;
        top: calc(var(--height) / 45);
        left: calc(var(--width) / 10);
        width: calc(var(--width)/ 1.13);
        object-fit: contain;
    }

    .cargo {
		background-color: green;
		color: white;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
	}
	
	.person {
		background-color: lightskyblue;
		color: black;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
	}
	
	.ally {
		background-color: blue;
		color: white;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
	}
	
	.encounter {
		background-color: purple;
		color: white;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
	}
	
	.location {
		background-color: yellow;
		color: black;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
	}
	
	.incident {
		background-color: red;
		color: white;
	}

    .ship {
        /*filter: drop-shadow(5px 5px 10px blue);*/
        /*box-shadow: 0 0 10px 5px red;*/
    }

    .mission {
        background-color: orange;
        color: white;
    }

    .text {
        background-color: #cd6666;
        border-radius: calc(var(--height) / 50);
    }

    .goal { 
        background-color: #b784a7;
        border-radius: calc(var(--height) / 50);
    }

    .values {
        position: absolute;
        top: calc(var(--height) / 7);
        left: 0;
        display: flex;
        flex-direction: column;
    }

    .traits {
        position: absolute;
        top: 0;
        right: calc(var(--width) / 30);
        width: calc(var(--width) / 2);
        display: flex;
        flex-wrap: wrap;
        align-content: flex-end;
        flex-direction: row;
        justify-content: flex-end;
    }

    .trait_image {
        height: calc(var(--width) / 10);
        width: calc(var(--width) / 10);
    }
    
    .trait_block {
        display: flex;
        flex-direction: column;
        
    }
    
    .trait_text {
        font-size: calc(var(--height) / 20);
        text-shadow: 0 0 2px white, 0 0 2px white, 0 0 2px white, 0 0 2px white;
        font-weight: bold;
        color: black;
        background-color: mediumpurple;
        writing-mode: vertical-rl;
        transform: rotate(180deg);
    }

    .species_text {
        background-color: orange;
    }

    .stripe {
         position: absolute;
         bottom: 0;
         right: 0;
         height: calc(var(--height) / 5);
         /*width: calc(var(--width) / 8);*/
    }

    .vp {
        position: absolute;
        bottom: calc(var(--height) / 100);
        right: calc(var(--width) / 30);
        font-weight: bold;
        font-size: calc(var(--height) / 12);
        text-align: right;
        height: calc(var(--height) / 10);
        width: calc(var(--width) / 8);
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
        color: lightblue;
        background-image: url(vp-positive.png);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .negative {
        color: pink;
        background-image: url(vp-negative.png);
    }

    .ships {
        position: absolute;
        top: calc(var(--height) / 7);
        left: calc(var(--width) / 30);
        display: flex;
        flex-direction: column;
    }

    .devcost {
        background-color: black;
        color: white;
        border-radius: calc(var(--height) / 50);
    }

    .reward {
        background-color: #F79768;
        border-radius: calc(var(--height) / 50);
    }

    .cleanup {
        background-color: lightgreen;
        border-radius: calc(var(--height) / 50);
    }

    .income {
        background-color: lightskyblue;
        border-radius: calc(var(--height) / 50);
    }
    
    .ongoing{
        background-color: #F8A33E;
        border-radius: calc(var(--height) / 50);
    }

    .text_holder {
        position: absolute;
        top: calc(var(--height) / 2.2);
        left: calc(var(--width) / 6.5);
        right: calc(var(--width) / 40);
        width: calc(var(--width) / 6.5) - calc(var(--width) / 40);
        /*font-size: calc(var(--width) / 14.3);*/
        height: calc(var(--height) / 3 + 1px);
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
    }

    .textitem {
        flex: 0 0;
    }

    .generic {
        background-color: grey;
        color: white;
        border-top: 2px solid black;
        border-bottom: 2px solid black;
    }

    .fitted_text {
        height: 100%;
        width: 100%;
        margin: calc(var(--width) / 50);
        width: calc(var(--width) / 6.5) - calc(var(--width) / 40);
    }

    .hovered {
        filter: blur(1)
    }

    .suits {
        position: absolute;
        bottom: calc(var(--height) / 100);
        left: calc(var(--width) / 5.72);
        right: calc(var(--width) / 5.72);
        display: flex;
        justify-content: center;
    }

    .ref {
        position: absolute;
        bottom: calc(var(--height) / 100);
        left: calc(var(--width) / 15);
        transform: rotate(-90deg);
        transform-origin: bottom left;
        font-size: calc(var(--width) / 30);
        font-weight: bold;
    }

    .pips {
        position: absolute;
        bottom: calc(var(--height) / 80);
        left: calc(var(--width) / 14);
        display: flex;
        flex-direction: column-reverse;
        max-height: calc(var(--height) / 5);
    }

    .pip {
        width: calc(var(--width) / 20);
        object-fit: contain;
        max-height: calc(var(--width) / 20);
    }

    .rotated {
        transform: rotate(180deg);
    }

    .value_image {
        object-fit: contain;
        max-height: calc(var(--height) / 10);
        min-width: calc(var(--width) / 4);
    }
</style>
